import React, {FunctionComponent, ReactNode} from "react";
import {validator} from "@reside/forms";
import {Formik} from "formik";
import {UserDto, ProfileUserDto} from "../../../../utils/types/user";
import {readableRole} from "../../../../atoms/list-table/helpers";

interface ProfileFormikProps {
  initialValues: UserDto;
  onSubmit: (values: ProfileUserDto) => void;
  children: ReactNode;
}

const buildInitialValues = ({
  firstName,
  lastName,
  email,
  phone,
  role,
}: UserDto) => ({
  firstName,
  lastName,
  email,
  phone,
  role: readableRole(role.name as any),
});

export const ProfileFormik: FunctionComponent<ProfileFormikProps> = ({
  initialValues,
  onSubmit,
  children,
  ...props
}) => {
  return (
    <Formik<ReturnType<typeof buildInitialValues>>
      {...props}
      initialValues={buildInitialValues(initialValues)}
      onSubmit={({role, email, ...user}) => onSubmit(user)}
      validate={values =>
        validator.validateAll(values, {
          firstName: "required",
          lastName: "required",
          phone: "required|phone",
        })
      }
      enableReinitialize
    >
      {children}
    </Formik>
  );
};
